import {Injectable, Injector} from '@angular/core';
import {BaseStormpathAccount, Stormpath} from 'angular-stormpath';
import {BehaviorSubject, Observable, Scheduler} from 'rxjs';
import {Router} from '@angular/router';
import {authConfig} from './auth.config';
import {Principal} from './principal.class';
import {UserService} from '../../../domain/model/user/user.service';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@Injectable()
export class AuthService {

    private readonly _userSubject = new BehaviorSubject<Principal | undefined>(undefined);

    readonly user$: Observable<Principal | undefined>;

    get user(): Principal | undefined { return this._userSubject.value; }

    userIsLoggedIn$: Observable<boolean>;

    private _userServiceValue: UserService;

    private get _userService(): UserService {
        //hack to break dependency cycle
        if (!this._userServiceValue) {
            this._userServiceValue = this._injector.get(UserService);
        }
        return this._userServiceValue;
    }

    constructor(private stormpath: Stormpath, private router: Router, private readonly _injector: Injector) {

        this.stormpath.user$
            .filter(user => !user || user['groups'])
            .map(user => user ? new Principal(user as BaseStormpathAccount) : undefined)
            .subscribe(this._userSubject);

        this.user$ = this._userSubject.observeOn(Scheduler.queue).switchMap(principal => {
            let observable: Observable<Principal | undefined>;

            if (principal) {
                //force user creation on first login
                observable = this._userService.createCurrentUserIfAbsent().map(wasCreated => {
                    principal.firstLogin = wasCreated;
                    return principal;
                });
            }
            else observable = Observable.of(principal);

            return observable;
        })
            .skip(1).publishReplay(1).refCount();

        this.userIsLoggedIn$ = this.user$.map(user => !!user);
    }

    redirectUnauthorizedUser(unauthorizedUrl: string) {
        return this.router.navigate([authConfig.unauthorizedUrlRedirect, {redirect: unauthorizedUrl}]);
    }

    logout() {
        this.stormpath.logout();
        this.userIsLoggedIn$
            .filter(it => !it)
            .first()
            .subscribe(_ => this.router.navigateByUrl(authConfig.logoutUrlRedirect));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/security/authorization/auth.service.ts